import { render, staticRenderFns } from "./OurServiceCard.vue?vue&type=template&id=c1d13ffc"
import script from "./OurServiceCard.vue?vue&type=script&lang=js"
export * from "./OurServiceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports